'use client';

import { useI18n } from '@/components/public/i18n/LocaleProvider';
import type { Locale, Translator } from '@/lib/i18n/core';
import { useEffect, useRef } from 'react';

type DemoWindow = Window & {
  RDVNodeDemo?: {
    mount: (root: HTMLElement, sector?: string, options?: { locale: Locale; translate: Translator }) => void;
    unmount: (root: HTMLElement) => void;
  };
};

export default function RNodeDemo({ inline = false }: { inline?: boolean }) {
  const { locale, t } = useI18n();
  const root = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const element = root.current;
    if (!element) return;
    let disposed = false;
    const mount = () => {
      if (!disposed) (window as DemoWindow).RDVNodeDemo?.mount(element, 'r-node', { locale, translate: t });
    };
    if ((window as DemoWindow).RDVNodeDemo) mount();
    else {
      let script = document.getElementById('rnode-demo-script') as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement('script');
        script.id = 'rnode-demo-script';
        script.src = '/assets/universes/rnode-demo.js';
        script.async = true;
        document.head.append(script);
      }
      script.addEventListener('load', mount, { once: true });
    }
    return () => {
      disposed = true;
      (window as DemoWindow).RDVNodeDemo?.unmount(element);
    };
  }, [locale, t]);
  return <div ref={root} data-demo-inline={inline ? 'true' : undefined} />;
}

